import { Button, MenuItem, TextField } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import { useGetSections } from "../../hooks/useGetSections";
import { useGetUser } from "../../hooks/useGetUser";
import axios from "axios";
import "./QuizCreation.css";

const QuizCreation = () => {
  const { user } = useGetUser();
  const [quiz, setQuiz] = useState();
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [sections, setSections] = useState();
  const [timeLimit, setTimeLimit] = useState();
  const [selectedSections, setSelectedSections] = useState([]);
  const [selectedSectionsID, setSelectedSectionsID] = useState([]);
  const { sectionData } = useGetSections();

  const history = useHistory();

  const handleSubmit = async () => {
    if (!name || !password || !timeLimit || !selectedSectionsID.length) {
      setError(true);
      setErrorMsg('Please fill all the fields')
      return;
    } else {
      setError(false);
      try {
        if (quiz) return; // update call
        const { data } = await axios.post(`https://computer-quiz-backend.herokuapp.com/quizzes`, {
          quiz_name: name,
          password: password,
          time_limit: timeLimit,
          year_section: selectedSectionsID
        },
        {
          headers: { 'api-token': localStorage.getItem('token') }
        }
        );
        setQuiz(data);
        history.push("/admin-quiz/" + data._id)
      } catch (error) {
        setError(true);
        setErrorMsg(JSON.stringify(error?.response?.data));
      }
    }
  };

  localStorage.setItem('user', user);

  useEffect(() => {
    setSections(sectionData);
  }, [sectionData]);

  const handleSelectedSections = event => {
    const value = event.target.value;
    let texts = [];
    for (const section of sections) {
      for (const val of value) {
        if (section._id === val) texts.push(section.year_section)
      }
    }
    setSelectedSections(texts);
    setSelectedSectionsID(value);
  };

  const handleRender = () => {
    selectedSections.map(section => {
      for (const section of sections) {
        if (section._id === section) return section.year_section;
      }
      return section;
    });
    return selectedSections.join(', ');
  };

  return (
    <div className="content">
      <div className="settings">
        <span style={{ fontSize: 30 }}>Quiz Settings</span>
        <div className="settings__select">
          { error && <ErrorMessage>{errorMsg}</ErrorMessage> }
          <TextField
            style={{ marginBottom: 25 }}
            label="Enter Quiz Name"
            variant="outlined"
            onChange={(e) => setName(e?.target?.value)}
          />
          <TextField
            style={{ marginBottom: 25 }}
            label="Enter Quiz Password"
            variant="outlined"
            type="password"
            onChange={(e) => setPassword(e?.target?.value)}
          />
          <InputLabel style={{ paddingLeft: 12 }} id="mutiple-select-label">Select sections</InputLabel>
          { sections &&
            <Select
              multiple
              label="Select Sections"
              labelId="mutiple-select-label"
              value={selectedSectionsID}
              name="selectedSections"
              id="selectedSections"
              variant="outlined"
              style={{ marginBottom: 30 }}
              onChange={handleSelectedSections}
              renderValue={handleRender}
            >
              {sections.map((cat) => (
                <MenuItem key={cat.year_section} value={cat._id}>
                  <ListItemIcon>
                    <Checkbox checked={selectedSectionsID.indexOf(cat._id) > -1} />
                  </ListItemIcon>
                  {/* {cat.year_section} */}
                  <ListItemText primary={cat.year_section} />
                </MenuItem>
              ))}
            </Select>
          }
          <TextField
            style={{ marginBottom: 25 }}
            label="Enter Time Limit In Seconds (ex: 300 for 5 mins)"
            variant="outlined"
            type="number"
            onChange={(e) => setTimeLimit(e?.target?.value)}
          />
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleSubmit}
          >
            Create Quiz
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuizCreation;
